import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hero-image',
  imports: [],
  templateUrl: './hero-image.component.html',
  styleUrl: './hero-image.component.scss',
})
export class HeroImageComponent {
  @Input() title?: string;
  @Input() imageUrl?: string;

  environment = environment;
}
